import { useAPI } from "hooks/api";

const MOCK_ENABLED = false;

// Normalises the PHP API response where every values field is a single-element
// array (e.g. { "title": ["My Event"] }) into plain strings.
function normalizeEvent(event) {
  const values = {};
  for (const [key, val] of Object.entries(event.values ?? {})) {
    values[key] = Array.isArray(val) ? val[0] ?? null : val;
  }
  return { ...event, values };
}

function normalizeEvents(data) {
  if (!Array.isArray(data)) return data;
  return data.map(normalizeEvent).filter((e) => e.values?.published === "Yes");
}
const SAMPLE_API_RESPONSE = [
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502744",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 11 Feb 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_2gMkApjjQjeIPI4icLo2cQ",
      ],
      webinar_id: ["84488259151"],
      description: [
        "Promote this event to empower employees juggling hybrid work and caring responsibilities. It offers both inspiration and structure to help them thrive—at work and in life.\n ",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Mini-Workshop: Finding Joy in Your 2026 Juggle - Tools to Flex, Care & Thrive",
      ],
      via: ["In Person"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502755",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 11 Nov 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_D9Mi4q0TStuADs1o6AtdtA",
      ],
      webinar_id: ["86360091187"],
      description: [
        "Share this session with leaders and teams to strengthen their confidence in managing parental leave transitions. It’s a great opportunity to promote inclusive conversations and reinforce your commitment to flexibility and retention.",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Masterclass : The Art & Compliance of Managing Parental Leave",
      ],
      via: ["Zoom"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502751",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 12 Aug 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_uhb-FflgRQeC4ACih1j62w",
      ],
      webinar_id: ["83671627561"],
      description: [
        "Invite leaders to attend this session to deepen their understanding of sponsorship and its role in accelerating gender equality. It offers practical insights grounded in research, helping managers use their influence intentionally to support women’s advancement and close structural gaps. Ideal for leaders committed to driving meaningful, measurable change.",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Masterclass : The Art & Research Behind Effective Sponsorship - Closing the Gender Pay Gap with Intention and Impact",
      ],
      via: ["Zoom"],
      is_registered: true,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502747",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 13 May 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_eEGKYqZSTIC_pyPTdUPbDQ",
      ],
      webinar_id: ["84773220348"],
      description: [
        "Share this session with leaders and teams to strengthen their confidence in managing parental leave transitions. It’s a great opportunity to promote inclusive conversations and reinforce your commitment to flexibility and retention.",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Masterclass : The Art & Compliance of Managing Parental Leave",
      ],
      via: ["Online"],
      is_registered: true,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502753",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 14 Oct 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_W55Sj0wpQd2C3kXO-2nk_A",
      ],
      webinar_id: ["88267566841"],
      description: [
        "Invite managers and team members to explore how caring responsibilities shape work across life stages. This session offers practical insights into navigating flexibility with empathy while supporting colleagues who are balancing care for children, ageing parents or both. Ideal for teams wanting to build a more inclusive, care-aware culture.",
      ],
      published: ["Yes"],
      title: [
        "LIVE Coaching : Caring Across Generations: Stories of Care and the Future of Flex",
      ],
      via: ["Zoom"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502752",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 16 Sep 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_6qwtQcOWT5mjnqXzYQc7Vg",
      ],
      webinar_id: ["82846832137"],
      description: [
        "Share this session with employees preparing for or returning from parental leave. It offers guidance on staying connected and confident through every stage of the journey.",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Masterclass : Preparing Your Parental Leave Roadmap",
      ],
      via: ["Zoom"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502749",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 17 Jun 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_uWz44TRGRyWRxPa3blIlcw",
      ],
      webinar_id: ["81918685309"],
      description: [
        "Invite men and leaders to attend this session exploring how social connection, wellbeing, and supportive workplaces strengthen men’s health. It’s ideal for teams wanting to better understand the pressures men face and create a culture where everyone feels seen, connected, and supported.",
      ],
      published: ["Yes"],
      title: [
        "LIVE Coaching: Men at Work: Men’s health, loneliness and the case for connection",
      ],
      via: ["Zoom"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502745",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 18 Mar 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_aGudaUkgTYyi63T6NozYPg",
      ],
      webinar_id: ["87594731255"],
      description: [
        "Share this session with employees preparing for or returning from parental leave. It offers guidance on staying connected and confident through every stage of the journey.",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Masterclass : Preparing Your Parental Leave Roadmap Navigating career and parental leave can be complex. Let’s make it easier.",
      ],
      via: ["Online"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502756",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 2 Dec 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_vxFEw7OsTDiyqBS5PqwJeA",
      ],
      webinar_id: ["89810996555"],
      description: [
        "Promote this event to support employees in navigating their return to the office with confidence. This session will provide valuable insights on balancing flexibility, setting boundaries, and making the transition smoother for everyone.",
      ],
      published: ["Yes"],
      title: ["Empowerment Masterclass : Return to Work with Confidence"],
      via: ["Zoom"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502743",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 21 Jan 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_BfaCHQioSG-8sSucOe6FgQ",
      ],
      description: [
        "Invite leaders and teams to attend this session to reimagine the workplace with empathy, flexibility, and fairness. It’s ideal for teams navigating the return to the office and evolving work practices.",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Masterclass: Flex Leadership - Building Your Team’s Hybrid Muscle",
      ],
      via: ["Online"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502754",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 21 Oct 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_PkO1p-XBSAeV-jRLpI_DFA",
      ],
      webinar_id: ["83774775365"],
      description: [
        "Share this session with women navigating menopause alongside the demands of work and care. It provides thoughtful guidance and practical tools to help them maintain confidence, manage competing pressures, and advocate for the support they need. A valuable event for any workplace aiming to better understand and uplift women in mid-life.",
      ],
      published: ["Yes"],
      title: [
        "LIVE Coaching : Addressing the Mid-Life Collision for Women: Menopause, Care & Career - Empowering women to thrive",
      ],
      via: ["Zoom"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502746",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 22 Apr 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_fovjNKC6T06APhSiCScONA",
      ],
      webinar_id: ["89188772695"],
      description: [
        "Encourage employees returning from parental leave to join this session for reassurance and clarity as they step back into work. It offers practical strategies to rebuild confidence, manage the transition, and set up sustainable routines that support both career and family. Perfect for team members wanting a smoother, more empowered return.",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Masterclass : You’ve Returned to Work - Are you Thriving or Surviving?",
      ],
      via: ["Online"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502750",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 22 Jul 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_ISYIJF75TcKkxCoRux5C4g",
      ],
      webinar_id: ["86368770323"],
      description: [
        "Promote this event to empower employees juggling hybrid work and caring responsibilities. It offers both inspiration and structure to help them thrive—at work and in life.\n ",
      ],
      published: ["Yes"],
      title: [
        "Empowerment Masterclass : Finding Joy in Your 2026 or Return to Work Juggle",
      ],
      via: ["Zoom"],
      is_registered: false,
    },
  },
  {
    childTableId: "0",
    createdAt: "2026-05-04T04:44:13+00:00",
    id: "212189502748",
    publishedAt: "2026-05-04T04:45:31+00:00",
    updatedAt: "2026-05-04T04:44:13+00:00",
    values: {
      date: ["Wed, 3 Jun 2026 @ 12pm AEST"],
      registration_url: [
        "https://us02web.zoom.us/webinar/register/WN_8YbDdO0VR6yJDpCsk3QyMg",
      ],
      webinar_id: ["86015902391"],
      description: [
        "Share this session with team members navigating the demands of caring for children, ageing parents, or both. It offers practical guidance on using flexibility well, supporting each other, and managing work responsibilities with confidence. A helpful event for anyone juggling the realities of modern family life.",
      ],
      published: ["Yes"],
      title: [
        "LIVE Coaching: Caring Across Generations: Reframing Flex for Family, Fathers, & Ageing Parents",
      ],
      via: ["In Person"],
      is_registered: true,
    },
  },
];
export function useEvents() {
  // eslint-disable-next-line no-undef
  if (typeof MOCK_ENABLED !== "undefined" && MOCK_ENABLED) {
    // eslint-disable-next-line no-undef
    return { status: "fetched", data: normalizeEvents(SAMPLE_API_RESPONSE) };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { statefulGet } = useAPI();
  const result = statefulGet("/coach-connect/events");
  return {
    ...result,
    data: result.data ? normalizeEvents(result.data) : result.data,
  };
}
